export default __webpack_public_path__ + "static/media/iconArrowLeft.864117a6.svg";